import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { CATEGORIES as PRODUCT_CATEGORIES, categorySlug } from "@/lib/categories";

const CATEGORIES = ["All", ...PRODUCT_CATEGORIES];

export default function Collection() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("All");
  const [sort, setSort] = useState("newest");

  useEffect(() => {
    const params = category === "All" ? {} : { category };
    api.get("/products", { params }).then((r) => setProducts(r.data)).catch(() => {});
  }, [category]);

  const sorted = [...products].sort((a, b) => {
    if (sort === "price-asc") return a.price - b.price;
    if (sort === "price-desc") return b.price - a.price;
    return 0;
  });

  return (
    <div className="pt-28 lg:pt-36 pb-24 max-w-[1600px] mx-auto px-6 lg:px-12">
      <div className="mb-12">
        <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-4">The Collection</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl font-light uppercase tracking-tight">
          All Pieces
        </h1>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 border-y border-white/10 py-5 mb-14">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              data-testid={`filter-${categorySlug(c)}`}
              onClick={() => setCategory(c)}
              className={`px-5 py-2 font-mono-label text-xs uppercase tracking-luxe border transition-colors ${
                category === c
                  ? "bg-white text-black border-white"
                  : "border-white/20 text-white/60 hover:text-white hover:border-white/50"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <select
          data-testid="sort-select"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="bg-transparent border border-white/20 text-white/70 font-mono-label text-xs uppercase tracking-luxe px-4 py-2 focus:outline-none focus:border-white/50"
        >
          <option value="newest" className="bg-black">Newest</option>
          <option value="price-asc" className="bg-black">Price: Low → High</option>
          <option value="price-desc" className="bg-black">Price: High → Low</option>
        </select>
      </div>

      {sorted.length === 0 ? (
        <p className="text-white/40 font-mono-label uppercase tracking-luxe text-sm py-20 text-center">
          No pieces in this category yet.
        </p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">
          {sorted.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
